import { EverythingAlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';
import { mainEverythingSearchRouteReference } from 'modules/main/main.routes';
import { HOME_PAGE_SLUGS } from 'utils/constants/general/homePageSlugs';

import { transformSearchFiltersToQueryParams } from './transformSearchFiltersToQueryParams';

type MainSearchRouteData = {
  lang: UserLocale;
  q: string;
  radius?: number | 'auto' | null;
  saved?: boolean;
  filters?: EverythingAlgoliaApiQueryFilters;
};

export function getMainEverythingSearchRoutePath(data: MainSearchRouteData) {
  const { lang, filters, q, radius, saved } = data;

  // Extract the segment based on type
  const segment = HOME_PAGE_SLUGS.ALL[lang];

  let queryParams = {
    q,
    radius,
    saved: saved || undefined,
  };

  if (filters) {
    // Merge basic and filter-derived query parameters
    queryParams = {
      ...queryParams,
      ...transformSearchFiltersToQueryParams(filters),
    };
  }

  return mainEverythingSearchRouteReference.with({
    lang,
    segment,
    ...queryParams,
  });
}
